// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] || chunkId) + "." + {"5":"cc6a4fa4","43":"33ebf8cb","234":"74df6141","653":"f1096dcd","844":"da8108b5"}[chunkId] + ".chunk.css";
};